module.exports = "<div class=\"modal-content salir-aplication\"><div class=modal-header><h5 class=modal-title><span>Sincronización de Pedidos</span></h5></div><div class=modal-body><div class=\"product-add clearfix\"><div class=\"row content-modal-body\">{{$ctrl.mensajeNotificacion}}</div><div class=\"row btn-actions\"><div class=col-xs-12><button type=button ng-click=mdCtrl.ok() class=\"btn btn-info\"><strong>Aceptar</strong></button></div></div></div></div></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./www/components/orders/sync-order-modal/sync-order-modal.view.html
 ** module id = 69
 ** module chunks = 8
 **/